"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This AnchorLink is to be used inside of [Anchor Component](#!/Anchor).
 * It provides the link to a specific anchor element
 */
var AnchorLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnchorLink, _React$Component);

  function AnchorLink() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, AnchorLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnchorLink)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleClick = function () {
      _this.context.anchor.scrollTo(_this.props.linkId);
    }, _temp));
  }

  _createClass(AnchorLink, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerLink(this.props.linkId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterLink(this.props.linkId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.linkId !== prevProps.linkId) {
        this.unregisterLink(prevProps.linkId);
        this.registerLink(this.props.linkId);
      }
    }
    /**
     * Register link to parent Anchor component
     * @param {string} linkId - link ID to register
     */

  }, {
    key: "registerLink",
    value: function registerLink(linkId) {
      this.context.anchor.registerLink(linkId);
    }
    /**
     * Unregister link to parent Anchor component
     * @param {string} linkId - link ID to unregister
     */

  }, {
    key: "unregisterLink",
    value: function unregisterLink(linkId) {
      this.context.anchor.unregisterLink(linkId);
    }
    /**
     * Handler for clicking on a link
     */

  }, {
    key: "isActive",

    /**
     * Returns if current anchor link is the active link
     * @returns {boolean} True of false if this link is the active link
     */
    value: function isActive() {
      return this.props.linkId === this.context.anchor.activeLink;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          hasError = _this$props.hasError,
          title = _this$props.title,
          children = _this$props.children,
          linkId = _this$props.linkId,
          props = _objectWithoutProperties(_this$props, ["className", "hasError", "title", "children", "linkId"]);

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "anchor-item ".concat(_ThemeManager.default.getVar('classPrefix'), "-anchor-link"), this.isActive() ? '-active' : '', hasError ? '-error' : ''),
        alignItems: "center",
        itemSpacing: "10px",
        onClick: this.handleClick
      }, props), _react.default.createElement("div", {
        className: "anchor-dot"
      }), _react.default.createElement("div", {
        className: "anchor-title"
      }, title), children);
    }
  }]);

  return AnchorLink;
}(_react.default.Component);

exports.default = AnchorLink;
AnchorLink.contextTypes = {
  anchor: _propTypes.default.object
};
AnchorLink.propTypes = {
  /**
   * Content to be displayed
   */
  children: _propTypes.default.node,

  /**
   * className is used to add extra class for adding new style to override
   * default
   */
  className: _propTypes.default.string,

  /**
   * Used to mark error on anchor link
   */
  hasError: _propTypes.default.bool,

  /**
   * Id of element to link to
   */
  linkId: _propTypes.default.string.isRequired,

  /**
   * Title of anchor link
   */
  title: _propTypes.default.string
};